export default __webpack_public_path__ + "static/media/loading.4ffcceb3.svg";